import { PlanningDay, PlanningType } from "@eisox/api/core-api";
import { z } from "@eisox/zod";

import { m } from "~/paraglide/messages";

export const planningSchema = (types: PlanningType[]) =>
  z.object({
    day: z.enum(PlanningDay),
    hourStart: z.string(),
    hourEnd: z.string(),
    type: z.enum(types),
    userDefined: z.boolean().optional(),
  });

export const copyToDaysSchema = z.object({
  mode: z.literal("by-day"),
  dayToCopy: z.enum(PlanningDay),
  targetDays: z.array(z.enum(PlanningDay)).min(1),
});

export const copyToRoomsSchema = z.object({
  mode: z.literal("to-another-place"),
  daysToCopy: z.array(z.enum(PlanningDay)).min(1),
  targetPlaces: z.array(z.string()).min(1),
});

export const copySchema = z.discriminatedUnion("mode", [copyToDaysSchema, copyToRoomsSchema]);
export type CopySchemaType = z.infer<typeof copySchema>;
export type CopyToDaysSchemaType = z.infer<typeof copyToDaysSchema>;
export type CopyToRoomsSchemaType = z.infer<typeof copyToRoomsSchema>;

export const updateSchema = z
  .object({
    begin: z.object({
      day: z.enum(PlanningDay),
      hour: z.string(),
    }),
    end: z.object({
      day: z.enum(PlanningDay),
      hour: z.string(),
    }),
    type: z.enum(PlanningType),
    copyToOtherDays: z.boolean(),
    targetDays: z.array(z.enum(PlanningDay)),
  })
  .refine(
    ({ copyToOtherDays, targetDays }) => {
      if (copyToOtherDays) return targetDays.length > 0;
      return true;
    },
    {
      error: m.planning_target_days_required(),
      path: ["targetDays"],
    },
  );

export type UpdateSchemaType = z.infer<typeof updateSchema>;
